export enum SubscriptionType {
  DIGITAL_MEMBERSHIP = "DIGITAL_MEMBERSHIP",
  PHONING = "PHONING",
}

export enum SubscriptionStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}
